module.exports = __webpack_public_path__ + "socicon.4e1bb964523f6f706d72.eot";


//////////////////
// WEBPACK FOOTER
// ./~/socicon/font/socicon.eot
// module id = 111
// module chunks = 13